import { useGetCustomerAccountingQuery } from 'store/queries/bolt-backend/customers'
import { selectCurrentAccountHasContractWithSubscriptionDateOlderThanOneDay } from 'store/contact/slice.ts'
import { useStoreSelector } from 'hooks/store.ts'

export const useCheckResubscriptionStatus = (): 'checking' | 'block' | 'allow' => {
  const { selected } = useStoreSelector((store) => store.contact)
  const hasContractOlderThanOneDay = useStoreSelector(selectCurrentAccountHasContractWithSubscriptionDateOlderThanOneDay)

  const { hasBadDebt, isLoading } = useGetCustomerAccountingQuery(
    { customerNumber: selected.account },
    {
      skip: !hasContractOlderThanOneDay,
      selectFromResult: ({ data, isLoading }) => ({
        isLoading,
        hasBadDebt: data?.hasBadDebt?.after45Days
      })
    }
  )

  if (isLoading) return 'checking'

  return hasBadDebt ? 'block' : 'allow'
}
